import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const arrItems = [
    {
        title: 'Пользователь вбивает ключевые слова',
        step: 'Шаг 1',
        icon: '/images/pic/linkbuilder/how1.png',
    },
    {
        title: 'Система анализирует выдачу Google и собирает уникальные домены для покупки ссылок',
        step: 'Шаг 2',
        icon: '/images/pic/linkbuilder/how2.png',
    },
    {
        title: 'Сервис автоматизирует коммуникацию с владельцами сайтов',
        step: 'Шаг 3',
        icon: '/images/pic/linkbuilder/how3.png',
    },
];

const HowWork = () => {
    return (
        <div className="linkbuilder-how__content-wrap">
            <FullWrapper smallPaddings={true} isMargin={false}>
                <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                    <div className="linkbuilder-how__content">
                        <CommonTitle>Как это работает?</CommonTitle>
                        <div className="linkbuilder-how__grid">
                            {arrItems.map((item, ind) => {
                                return (
                                    <ScrollAnimation
                                        animateIn="fadeInUp"
                                        offset={100}
                                        animateOnce={true}
                                        key={ind}
                                        duration={ind + 0.3}
                                        className="linkbuilder-how-item__box"
                                    >
                                        <div className="linkbuilder-how-item">
                                            <div className="linkbuilder-how-item__img">
                                                <img src={item.icon} alt="" loading="lazy" />
                                            </div>
                                            <div className="linkbuilder-how-item__step">
                                                {item.step}
                                            </div>
                                            <div className="linkbuilder-how-item__title">
                                                {item.title}
                                            </div>
                                        </div>
                                    </ScrollAnimation>
                                );
                            })}
                        </div>
                    </div>
                </ScrollAnimation>
            </FullWrapper>
        </div>
    );
};

export default HowWork;
